import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { StorefrontContext } from '../../service/storefront-context';
import { WebsiteService } from '../../service/website.service';
import { SocialComponent } from './social.component';

@Component({
  selector: 'page-footer',
  imports: [RouterLink, SocialComponent],
  host: {
    style: 'display: contents'
  },
  template: `
    <!-- Footer -->
    <footer class="bg6 p-t-45 p-b-43 p-l-45 p-r-45">
      <div class="flex-w p-b-90">
        <div class="w-size6 p-t-30 p-l-15 p-r-15 respon3">
          <h4 class="s-text12 p-b-30">
            Завжди на зв’язку
          </h4>
          <div>
            <p class="s-text7 w-size27">
              Запитання? Телефонуйте: <a class="s-text7" [href]="'tel:' + website().phone">{{website().phone}}</a>
              або отримайте детальнішу інформацію на сторінці
              <a routerLink="/contacts" class="s-text7"><u>контактів</u></a>
            </p>
            <div class="flex-m p-t-30">
              <social />
            </div>
          </div>
        </div>

        <div class="w-size12 p-t-30 p-l-15 p-r-15 respon4">
          <h4 class="s-text12 p-b-30">
            Категорії
          </h4>

          <ul>
            @for (category of website().categories ?? []; track $index) {
              <li class="p-b-9 footer-category">
                <a class="s-text7" [routerLink]="'/' + category.code">
                  {{category.name}}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="w-size12 p-t-30 p-l-15 p-r-15 respon4">
          <h4 class="s-text12 p-b-30">
            Магазин
          </h4>

          <ul>
            <li class="p-b-9">
              <a routerLink="/about" class="s-text7">
                Про нас
              </a>
            </li>

            @for (page of website().websitePages ?? []; track $index) {
              <li class="p-b-9">
                <a class="s-text7" [routerLink]="'/' + page.code">
                  {{page.name}}
                </a>
              </li>
            }

            <li class="p-b-9">
              <a routerLink="/contacts" class="s-text7">
                Контакти
              </a>
            </li>
          </ul>
        </div>

        <div class="w-size8 p-t-30 p-l-15 p-r-15 respon3">
          <h4 class="s-text12 p-b-30">
            Допомога
          </h4>
          <ul>
            <li class="p-b-9">
              <a routerLink="/questions" fragment="order-state" class="s-text7">
                Який стан мого замовлення?
              </a>
            </li>
            <li class="p-b-9">
              <a routerLink="/questions" fragment="return-policy" class="s-text7">
                На які товари розповсюджується право повернення у 14-денний термін?
              </a>
            </li>
            @for (link of website().links ?? []; track $index) {
              <li class="p-b-9">
                <a class="s-text7" [routerLink]="'/' + link.href">
                  {{link.name}}
                </a>
              </li>
            }
          </ul>
        </div>
      </div>

      <div class="t-center p-l-15 p-r-15">
        <div class="t-center s-text8 p-t-20">
          © {{context.year()}} Всі права захищені. | Цей шаблон створено з
          <i class="fa fa-heart-o" aria-hidden="true"></i> компанією
          <a href="https://colorlib.com" target="_blank">Colorlib</a>
        </div>
      </div>
    </footer>

    <!-- Back to top -->
    <div id="back-to-top-container">
      <div class="btn-back-to-top bg0-hov" id="back-to-top">
        <span class="symbol-btn-back-to-top">
          <i class="fa fa-angle-double-up" aria-hidden="true"></i>
        </span>
      </div>
    </div>
    `
})
export class FooterComponent {

  readonly website = inject(WebsiteService).current;
  readonly context = inject(StorefrontContext);

}
